import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {DashAlert} from '../../kitchen/shared/domain/alerts/dash-alert.model';
import {StatusChangeLine} from '../../kitchen/shared/domain/alerts/status-change-line.model';
import {StatusRequest} from '../../kitchen/shared/domain/alerts/status-request.model';
import {AlertRequest} from '../../kitchen/shared/domain/alerts/alert-request.model';

@Injectable()
export class AdStatsAlertsService {
  widgetRequest: AlertRequest; //use this to communicate last request run on alerts widget before redirection to alerts component where it will be run again

  constructor(private http: HttpClient) {
  }

  alerts(request: AlertRequest): Observable<DashAlert[]> {
    return this.http.post<DashAlert[]>(`${environment.serviceUrl}/ad-stats/alerts`, request);
  }

  statusChanges(request: StatusRequest): Observable<StatusChangeLine[]> {
    return this.http.post<StatusChangeLine[]>(`${environment.serviceUrl}/ad-stats/status-changes`, request);
  }
  statusChangesEmail(params: { emails: string[], comment: string, lines: StatusChangeLine[] }): Observable<any> {
    return this.http.post<any>(`${environment.serviceUrl}/ad-stats/status-changes/email`, params);
  }
}
